const seriesColours = ['0, 28, 53', '0, 148, 204', '242, 168, 5', '163, 228, 86', '196, 44, 61', '77, 77, 77'];

export default seriesColours;
